import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { type CannedMessage } from 'entities/CannedMessages/model/CannedMessage'
import { SavedReplyItem } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/SavedRepliesListContent/SavedRepliesList/SavedReplyItem/SavedReplyItem'

import styles from './styles.module.scss'

type ISavedRepliesListProps = {
  list: CannedMessage[]
  title?: string
}

export const SavedRepliesList: FC<ISavedRepliesListProps> = observer(({ list, title }) => {
  return (
    <div className={styles.wrapList}>
      {!!list.length && (
        <div className={styles.list}>
          {title && (
            <div className={styles.wrapLabel}>
              <Typography
                variant={'body-sm-medium'}
                color={'var(--content-primary-tertiary)'}
                ariaLabel={'My replies'}
              >
                {title}
              </Typography>
            </div>
          )}
          {list.map((item) => (
            <SavedReplyItem key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  )
})
